export default __webpack_public_path__ + "static/media/forget_password-background.0fdc8bd4.png";